// extracted by mini-css-extract-plugin
export var blockquote = "LinkButton-module--blockquote--bdb1e";
export var bulletList = "LinkButton-module--bulletList--91b30";
export var buttonText = "LinkButton-module--buttonText--e300b";
export var figcaption = "LinkButton-module--figcaption--06fac";
export var h1 = "LinkButton-module--h1--2c8ee";
export var h2 = "LinkButton-module--h2--74927";
export var h3 = "LinkButton-module--h3--76fa8";
export var h4 = "LinkButton-module--h4--0c249";
export var h5 = "LinkButton-module--h5--2ca60";
export var h6 = "LinkButton-module--h6--234bd";
export var lede = "LinkButton-module--lede--48b5f";
export var linkButton = "LinkButton-module--linkButton--8a1ca";
export var linkButtonSmall = "LinkButton-module--linkButtonSmall--82d1f";
export var linkHoverOnly = "LinkButton-module--linkHoverOnly--22d0a";
export var linkStyle = "LinkButton-module--linkStyle--aed16";
export var linkbg = "LinkButton-module--linkbg--9707c";
export var meta = "LinkButton-module--meta--1d0a0";
export var nav = "LinkButton-module--nav--b5b86";
export var noDecoration = "LinkButton-module--noDecoration--e69ff";
export var p = "LinkButton-module--p--bb21f";
export var pSmall = "LinkButton-module--pSmall--7ac2c";
export var semibold = "LinkButton-module--semibold--060c6";
export var strong = "LinkButton-module--strong--0adb7";
export var textColorMidnight = "LinkButton-module--textColorMidnight--68ded";
export var textColorMilk = "LinkButton-module--textColorMilk--41cf4";
export var uppercase = "LinkButton-module--uppercase--ce178";